import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Auth/Login.vue";
import store from "../store/index.js";
// Amplify読み込み
import { components, AmplifyEventBus } from "aws-amplify-vue"; // eslint-disable-line
//import { AmplifyEventBus } from 'aws-amplify-vue'
import Amplify, * as AmplifyModules from "aws-amplify"; // eslint-disable-line
import { AmplifyPlugin } from "aws-amplify-vue";
import { Auth } from "@aws-amplify/auth";

Vue.use(VueRouter);
Vue.use(AmplifyPlugin, AmplifyModules);

let user;

getUser().then((user) => {
  if (user) {
    //router.push('/', () => { })//強制ルート移動
  } else {
    router.push("/login", () => {});
  }
});

function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
    .then((data) => {
      if (data && data.signInUserSession) {
        store.commit("setUser", data);
        store.commit("setAuth", true);
        return data;
      }
    })
    .catch(() => {
      store.commit("setUser", null);
      store.commit("logOut");
      return null;
    });
}

async function getAccessToken() {
  const res1 = Auth.currentAuthenticatedUser();
  const res2 = Auth.currentSession();
  const [cognitoUser, currentSession] = await Promise.all([res1, res2]);
  await refreshToken(cognitoUser, currentSession);
}

function refreshToken(cognitoUser, currentSession) {
  return new Promise((resolve) => {
    cognitoUser.refreshSession(currentSession.refreshToken, (err, res) => {
      const { accessToken } = res;
      store.commit("setAccessToken", accessToken.jwtToken);
      resolve();
    });
  });
}

async function getCredentialID() {
  try {
    const tmp = await Auth.currentCredentials();
    store.commit("setCredential", tmp.identityId);
  } catch (err) {
    store.commit("setCredential", null);
  }
}

// ログイン状態管理
AmplifyEventBus.$on("authState", async (state) => {
  if (state === "signedOut") {
    store.commit("logOut");
    //router.push({path: '/login'});
    router.push("/login", () => {});
  } else if (state === "signedIn") {
    store.commit("setAuth", true);
    await getUser();
    await getAccessToken();
    await getCredentialID();
    //router.push({path: '/'});
    router.push("/", () => {});
  }
});

const routes = [
  { path: "/", name: "Home", component: Home, meta: { requiresAuth: true } },
  { path: "/login", name: "login", component: Login },
  //Project Custom
  {
    path: "/customer/:id",
    name: "CustomerIndex",
    component: () => import(/**/ "../views/Customer/index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:id/report_builder",
    name: "BuilderIndex",
    component: () => import(/**/ "../views/Builder/Index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:id/setting",
    name: "Setting",
    component: () => import(/**/ "../views/Setting/Setting.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:id/router",
    name: "RouterBuilder",
    component: () => import("../views/Builder/RouterBuilder.vue"),
    meta: { requiresAuth: true },
  },
  //Builder Page
  {
    path: "/customer/:id/page/:page_id/index_builder",
    name: "IndexBuilderCreate",
    component: () => import("../views/Builder/CreateIndex.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:id/page/:page_id/menu_builder",
    name: "MenuBuilderCreate",
    component: () => import("../views/Builder/CreateMenu.vue"),
    meta: { requiresAuth: true },
  },
  //新バージョン //{ path: '/customer/:id/page/:page_id/report_builder',       name: 'ReportBuilderCreate',    component: () => import('../views/Builder/CreateReport/CreateReport.vue'), meta: { requiresAuth: true },props: true },
  {
    path: "/customer/:id/page/:page_id/report_builder",
    name: "ReportBuilderCreate",
    component: () => import("../views/Builder/CreateReport.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/customer/:id/page/:page_id/subreport_builder",
    name: "SubReportBuilderCreate",
    component: () => import("../views/Builder/CreateReport.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/customer/:id/page/:page_id/MainMenu_builder",
    name: "MainMenuBuilderCreate",
    component: () => import("../views/Builder/CreateMainMenu.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:id/page/:page_id/CsvImport_builder",
    name: "CsvImportBuilderCreate",
    component: () => import("../views/Builder/CreateCsvImport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:id/page/:page_id/calenderindex_builder",
    name: "CalenderIndexCreate",
    component: () => import("../views/Builder/CreateCalenderIndex.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:id/page/:page_id/graph_builder",
    name: "GraphViewCreate",
    component: () => import("../views/Builder/CreateGraphView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/:id/page/:page_id/user_report_builder",
    name: "UserReportBuilderCreate",
    component: () => import("../views/Builder/CreateReport.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/customer/:id/page/:page_id/user_index_builder",
    name: "UserIndexBuilderCreate",
    component: () => import("../views/Builder/CreateIndex.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/customer/:id/page/:page_id/mail_send_builder",
    name: "MailSendBuilderCreate",
    component: () => import("../views/Builder/CreateReport.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/customer/:id/page/:page_id/second_auth_builder",
    name: "SecondAuthCreate",
    component: () => import("../views/Builder/CreateReport.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/customer/:id/page/:page_id/master_sub",
    name: "mastarSubCreate",
    component: () => import("../views/Builder/CreateReport.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/customer/:id/page/:page_id/batch_approval",
    name: "UserIndexBuilderCreate",
    component: () => import("../views/Builder/CreateIndex.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  //PewView Page
  {
    path: "/customer/:id/preview/:page_id/report_create",
    name: "PreviewReportCreate",
    component: () => import("../views/Preview/ReportCreate/PreviewReport.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  //Developer Setting
  {
    path: "/developer/index",
    name: "DeveloperIndex",
    component: () => import("../views/DeveloperSetting/DeveloperHome.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/developer/customer",
    name: "DeveloperSetting",
    component: () => import("../views/DeveloperSetting/DeveloperSetting.vue"),
    meta: { requiresAuth: true },
  },
  //Customer Setting
  {
    path: "/customer/project/home",
    name: "CustomerHome",
    component: () => import("../views/CustomerSetting/CustomerHome.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/project/Create",
    name: "CustomerCreate",
    component: () => import("../views/CustomerSetting/CustomerCreate.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer/project/Copy",
    name: "CustomerCopy",
    component: () => import("../views/CustomerSetting/CustomerCopy.vue"),
    meta: { requiresAuth: true },
  },
  //Employee Setting
  {
    path: "/employee/home",
    name: "EmployeeHome",
    component: () => import("../views/EmployeeSetting/EmployeeHome.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/employee/UserCreate",
    name: "EmployeeCreate",
    component: () => import("../views/EmployeeSetting/EmployeeCreate.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/employee/UserDelete",
    name: "EmployeeDelete",
    component: () => import("../views/EmployeeSetting/EmployeeDelete.vue"),
    meta: { requiresAuth: true },
  },
  //モック作成画面
  {
    path: "/mock/create",
    name: "MockCreate",
    component: () => import("../views/mock/mockCreate.vue"),
    meta: { requiresAuth: true },
  },
  //分析画面
  {
    path: "/analysis",
    name: "Analysis",
    component: () => import("../views/Analysis/Analysis.vue"),
    meta: { requiresAuth: true },
  },
];
// ルーティング設定
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// リダイレクト設定
router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const res1 = getUser();
    const res2 = getAccessToken();
    const [res3] = await Promise.all([res1, res2]);
    user = res3;

    await getCredentialID();
    if (!user) {
      return next({
        path: "/login",
      });
    }

    return next();
  }
  return next();
});
export default router;
